/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IHound, IHoundInterface } from "../IHound";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "houndId",
        type: "uint256",
      },
    ],
    name: "hound",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "staminaLastUpdate",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaValue",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.Stamina",
            name: "stamina",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "lastBreed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "externalBreedingFee",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "availableToBreed",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Breeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "femaleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "generation",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "birthDate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "specie",
                type: "uint256",
              },
              {
                internalType: "uint32[72]",
                name: "geneticSequence",
                type: "uint32[72]",
              },
              {
                internalType: "string",
                name: "extensionTraits",
                type: "string",
              },
            ],
            internalType: "struct Hound.Identity",
            name: "identity",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "token_uri",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "runningOn",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "custom",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Profile",
            name: "profile",
            type: "tuple",
          },
        ],
        internalType: "struct Hound.Struct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IHound__factory {
  static readonly abi = _abi;
  static createInterface(): IHoundInterface {
    return new utils.Interface(_abi) as IHoundInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): IHound {
    return new Contract(address, _abi, signerOrProvider) as IHound;
  }
}
